document.documentElement.classList.remove('no-js');

function initKJHSTheme(){
  initMenu();
  initSelects();
  initProduct();
  initProductExtras();
  initManualBundles();
  initCartVolumeProgress();
  initCartInventoryLimits();
  initInvoiceRequest();
  initQuizFallbackLinks();
}

document.addEventListener('DOMContentLoaded', initKJHSTheme);
document.addEventListener('shopify:section:load', initKJHSTheme);

function initMenu(){
  const drawer=document.querySelector('[data-kjhs-drawer]');
  if(!drawer||drawer.dataset.kjhsMenuReady==='true')return;
  drawer.dataset.kjhsMenuReady='true';
  const openers=document.querySelectorAll('[data-kjhs-drawer-open]');
  const closers=drawer.querySelectorAll('[data-kjhs-drawer-close]');
  const setOpen=open=>{
    drawer.classList.toggle('is-open',open);
    drawer.setAttribute('aria-hidden',String(!open));
    document.body.classList.toggle('kjhs-drawer-open',open);
    openers.forEach(btn=>btn.setAttribute('aria-expanded',String(open)));
    if(open)setTimeout(()=>drawer.querySelector('.drawer-close')?.focus(),30);
  };
  openers.forEach(btn=>btn.addEventListener('click',()=>setOpen(true)));
  closers.forEach(btn=>btn.addEventListener('click',()=>setOpen(false)));
  drawer.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>setOpen(false)));
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&drawer.classList.contains('is-open'))setOpen(false)});
}

function initSelects(){
  document.querySelectorAll('[data-sort-select]').forEach(select=>{
    if(select.dataset.kjhsSelectReady==='true')return;
    select.dataset.kjhsSelectReady='true';
    select.addEventListener('change',()=>select.form&&select.form.submit());
  });
}

function initProduct(){
  const root=document.querySelector('[data-product-root]');
  if(!root||root.dataset.kjhsProductInitialized==='true')return;
  root.dataset.kjhsProductInitialized='true';
  const j=root.querySelector('[data-product-json]');
  if(!j)return;
  let variants=[];
  try{variants=JSON.parse(j.textContent)}catch(e){return}

  const selected={};
  root.querySelectorAll('[data-option-index]').forEach(g=>{
    const b=g.querySelector('.variant-button.is-selected');
    const sel=g.querySelector('[data-option-select]');
    if(b)selected[Number(g.dataset.optionIndex)]=b.dataset.optionValue;
    else if(sel)selected[Number(g.dataset.optionIndex)]=sel.value;
  });

  const idInput=root.querySelector('[data-variant-id]');
  const priceEl=root.querySelector('[data-product-price]');
  const compareEl=root.querySelector('[data-product-compare]');
  const stockEl=root.querySelector('[data-stock-state]');
  const addBtn=root.querySelector('[data-add-to-cart]');
  const addLabel=root.querySelector('[data-add-label]');
  const formError=root.querySelector('[data-product-form-error]');
  const qtyInput=root.querySelector('[data-quantity-input]');
  const totalEl=root.querySelector('[data-quantity-total]');
  const form=root.querySelector('[data-product-form]');
  const sticky=root.querySelector('[data-sticky-atc]');
  const stickySubmit=root.querySelector('[data-sticky-submit]');
  const stickyPrice=root.querySelector('[data-sticky-price]');
  const stickyQty=root.querySelector('[data-sticky-qty]');
  const gallery=root.querySelector('[data-product-gallery]');
  const requiresColorSelection=root.dataset.requiresColorSelection==='true';
  const explicitVariantId=new URL(window.location.href).searchParams.get('variant');
  const hasExplicitVariant=!!explicitVariantId&&variants.some(v=>String(v.id)===String(explicitVariantId));
  let colorSelectionPending=requiresColorSelection&&!hasExplicitVariant;
  let current=variants.find(v=>String(v.id)===String(hasExplicitVariant?explicitVariantId:idInput?.value))||variants[0];
  const currency=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR';
  const money=c=>{try{return new Intl.NumberFormat(document.documentElement.lang||'it-IT',{style:'currency',currency}).format(c/100)}catch(e){return (c/100).toFixed(2)+' €'}};

  const selectedOptions=()=>Object.keys(selected).sort((a,b)=>a-b).map(k=>selected[k]);
  const variantForSelection=()=>{
    const opts=selectedOptions();
    const optionCount=variants[0]?.options?.length||0;
    if(!optionCount||opts.length!==optionCount)return null;
    return variants.find(v=>v.options.every((value,index)=>value===opts[index]))||null;
  };
  const setVariantInput=v=>{
    if(!idInput||!v?.id)return;
    const value=String(v.id);
    idInput.value=value;
    idInput.defaultValue=value;
    idInput.setAttribute('value',value);
  };
  const synchronizeVariantId=()=>{
    const resolved=variantForSelection()||variants.find(v=>String(v.id)===String(idInput?.value))||current||null;
    if(resolved){
      current=resolved;
      setVariantInput(resolved);
    }
    return resolved;
  };
  const clearFormError=()=>{
    if(!formError)return;
    formError.hidden=true;
    formError.textContent='';
  };
  const showFormError=message=>{
    if(!formError)return;
    formError.textContent=message||addBtn?.dataset.errorLabel||'Unable to add this product to the cart.';
    formError.hidden=false;
  };

  const stockLimit=v=>{
    if(!v||!v.available)return 0;
    if(v.inventory_management && v.inventory_policy!=='continue')return Math.max(0,Number(v.inventory_quantity||0));
    return Infinity;
  };

  const rootPath=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  let cartSnapshot=null;
  const qtyMinusBtn=root.querySelector('[data-qty-minus]');
  const qtyPlusBtn=root.querySelector('[data-qty-plus]');
  const cartQtyForVariant=id=>{
    if(!cartSnapshot||!Array.isArray(cartSnapshot.items))return 0;
    return cartSnapshot.items
      .filter(item=>String(item.variant_id||item.id)===String(id))
      .reduce((sum,item)=>sum+Math.max(0,Number(item.quantity||0)),0);
  };
  const remainingStock=v=>{
    const total=stockLimit(v);
    if(!Number.isFinite(total))return Infinity;
    return Math.max(0,total-cartQtyForVariant(v?.id));
  };
  const fetchCartSnapshot=async(force=false)=>{
    if(cartSnapshot&&!force)return cartSnapshot;
    try{
      cartSnapshot=await fetch(`${rootPath}cart.js`,{headers:{'Accept':'application/json'},cache:'no-store'}).then(r=>r.json());
    }catch(e){
      cartSnapshot=cartSnapshot||{items:[]};
    }
    return cartSnapshot;
  };
  const stockMessage=(template,count)=>String(template||'').replaceAll('__count__',String(Math.max(0,count)));

  const bundleSelector=root.querySelector('[data-bundle-selector]');
  const bundleButtons=[...root.querySelectorAll('[data-bundle-qty]')];
  const tierRules=bundleButtons
    .map(btn=>({qty:Number(btn.dataset.bundleQty||0),discount:Math.max(0,Number(btn.dataset.discountPercent||0)),btn}))
    .filter(rule=>rule.qty>0)
    .sort((a,b)=>a.qty-b.qty);
  const discountForQty=q=>{
    let discount=0;
    tierRules.forEach(rule=>{if(q>=rule.qty)discount=rule.discount});
    return discount;
  };
  const tierForQty=q=>{
    let active=tierRules[0]||null;
    tierRules.forEach(rule=>{if(q>=rule.qty)active=rule});
    return active;
  };
  const discountedTotal=(price,q)=>Math.round(price*q*(100-discountForQty(q))/100);

  const recommendedRange=(()=>{
    const raw=(bundleSelector?.dataset.recommendedQuantity||'').replace(/ /g,' ');
    const values=(raw.match(/\d+(?:[.,]\d+)?/g)||[]).map(v=>Number(v.replace(',','.'))).filter(v=>Number.isFinite(v)&&v>0&&v<=30);
    if(!values.length)return null;
    return {min:Math.min(...values),max:Math.max(...values)};
  })();

  const updateBundles=()=>{
    const limit=remainingStock(current);
    const q=Math.max(1,parseInt(qtyInput?.value||1,10));
    const stockTemplate=bundleSelector?.dataset.onlyStock||'Only __count__ available';
    const fullPriceLabel=bundleSelector?.dataset.fullPriceLabel||'Full price';
    const saveLabel=bundleSelector?.dataset.saveLabel||'Save';
    const packsLabel=bundleSelector?.dataset.packsLabel||'packs';
    const packLabel=bundleSelector?.dataset.packLabel||'pack';
    const totalLabel=bundleSelector?.dataset.totalLabel||'Total';
    const activeTier=tierForQty(q);

    bundleButtons.forEach(btn=>{
      const amount=Number(btn.dataset.bundleQty);
      const discount=Math.max(0,Number(btn.dataset.discountPercent||0));
      const disabled=Number.isFinite(limit)&&limit<amount;
      btn.disabled=disabled;
      btn.classList.toggle('is-disabled',disabled);
      btn.setAttribute('aria-disabled',String(disabled));

      const stock=btn.querySelector('[data-bundle-stock]');
      if(stock)stock.textContent=disabled?stockTemplate.replace('__count__',String(limit)):'';

      const raw=current.price*amount;
      const discounted=Math.round(raw*(100-discount)/100);
      const saving=Math.max(0,raw-discounted);
      const unit=Math.round(discounted/amount);
      const totalNode=btn.querySelector('[data-bundle-total-price]');
      const unitNode=btn.querySelector('[data-bundle-unit-price]');
      const savingNode=btn.querySelector('[data-bundle-saving]');
      if(totalNode)totalNode.textContent=money(discounted);
      if(unitNode)unitNode.textContent=money(unit);
      if(savingNode)savingNode.textContent=discount>0?`${saveLabel} ${money(saving)}`:fullPriceLabel;

      const selected=activeTier&&activeTier.qty===amount;
      btn.classList.toggle('is-selected',!!selected);
      btn.setAttribute('aria-pressed',String(!!selected));

      const recommended=btn.querySelector('[data-tier-recommended]');
      if(recommended){
        const isRecommended=!!recommendedRange&&amount>=recommendedRange.min&&amount<=recommendedRange.max&&amount>1;
        recommended.hidden=!isRecommended;
      }
    });

    const summary=bundleSelector?.querySelector('[data-bundle-summary]');
    if(summary&&activeTier){
      const amount=activeTier.qty;
      const discount=Math.max(0,Number(activeTier.discount||0));
      const raw=current.price*amount;
      const discounted=Math.round(raw*(100-discount)/100);
      const saving=Math.max(0,raw-discounted);
      const unit=Math.round(discounted/amount);
      const qtyNode=summary.querySelector('[data-bundle-summary-qty]');
      const unitNode=summary.querySelector('[data-bundle-summary-unit]');
      const savingNode=summary.querySelector('[data-bundle-summary-saving]');
      const totalNode=summary.querySelector('[data-bundle-summary-total]');
      if(qtyNode)qtyNode.textContent=`${amount} ${amount===1?packLabel:packsLabel}`;
      if(unitNode)unitNode.textContent=`${money(unit)} / ${packLabel}`;
      if(savingNode)savingNode.textContent=discount>0?`${saveLabel} ${money(saving)}`:fullPriceLabel;
      if(totalNode)totalNode.textContent=`${totalLabel} ${money(discounted)}`;
    }

    const bogo=root.querySelector('[data-bogo-add-three]');
    if(bogo){
      const unavailable=Number.isFinite(limit)&&limit<3;
      bogo.disabled=unavailable||!current?.available;
    }
  };

  const updateTotal=()=>{
    if(!current||!qtyInput)return;
    let q=Math.max(1,parseInt(qtyInput.value||1,10));
    const totalStock=stockLimit(current);
    const limit=remainingStock(current);
    const exhausted=Number.isFinite(limit)&&limit<=0;

    if(Number.isFinite(limit)){
      qtyInput.max=String(Math.max(0,limit));
      if(limit>0)q=Math.min(q,limit);
    }else{
      qtyInput.removeAttribute('max');
    }
    qtyInput.value=q;
    qtyInput.disabled=exhausted||!current.available;
    if(qtyMinusBtn)qtyMinusBtn.disabled=exhausted||q<=1;
    if(qtyPlusBtn)qtyPlusBtn.disabled=exhausted||(Number.isFinite(limit)&&q>=limit);

    if(addBtn&&!colorSelectionPending){
      addBtn.disabled=!current.available||exhausted;
      addBtn.hidden=!current.available;
    }
    if(stickySubmit)stickySubmit.disabled=!current.available||exhausted||colorSelectionPending;

    if(stockEl&&current.available&&Number.isFinite(totalStock)){
      const inCart=cartQtyForVariant(current.id);
      const availableLabel=root.dataset.stockCountLabel||'disponibili';
      const inCartLabel=root.dataset.stockInCartLabel||'già nel carrello';
      const moreLabel=root.dataset.stockMoreLabel||'ancora aggiungibili';
      if(inCart>0&&limit<=0){
        stockEl.textContent=`${totalStock} ${availableLabel} · ${inCart} ${inCartLabel} · ${root.dataset.stockCartFullShort||'quantità massima già nel carrello'}`;
      }else if(inCart>0){
        stockEl.textContent=`${totalStock} ${availableLabel} · ${inCart} ${inCartLabel} · ${limit} ${moreLabel}`;
      }else{
        stockEl.textContent=`${totalStock} ${availableLabel}`;
      }
    }

    const displayTotal=discountedTotal(current.price,q);
    if(totalEl)totalEl.textContent=money(displayTotal);
    if(stickyPrice)stickyPrice.textContent=money(displayTotal);
    if(stickyQty)stickyQty.textContent=`${q} ×`;
    if(addLabel){
      const base=addLabel.dataset.add||'Aggiungi al carrello';
      addLabel.textContent=`${base} · ${money(displayTotal)}`;
    }
    updateBundles();
  };

  const updateColorSummary=(button)=>{
    if(!button||!button.matches('[data-color-choice]'))return;
    const fieldset=button.closest('.product-option');
    if(!fieldset)return;
    const label=fieldset.querySelector('[data-color-selected-label]');
    if(label)label.textContent=button.dataset.optionValue||'';
    const trigger=fieldset.querySelector('[data-color-picker-open]');
    const action=fieldset.querySelector('[data-color-trigger-action]');
    const choiceImg=button.querySelector('img');
    if(choiceImg?.dataset.colorThumbnailSrc&&!choiceImg.getAttribute('src')){
      choiceImg.src=choiceImg.dataset.colorThumbnailSrc;
    }
    trigger?.classList.remove('is-awaiting-selection');
    if(action)action.innerHTML=`${action.dataset.changeLabel||action.textContent.replace('→','').trim()} <span aria-hidden="true">→</span>`;
    if(trigger&&choiceImg){
      let triggerImg=trigger.querySelector('.color-picker-trigger__image');
      if(!triggerImg){
        triggerImg=document.createElement('img');
        triggerImg.className='color-picker-trigger__image';
        const placeholder=trigger.querySelector('.color-picker-trigger__placeholder');
        if(placeholder)placeholder.replaceWith(triggerImg);
        else trigger.prepend(triggerImg);
      }
      triggerImg.src=choiceImg.currentSrc||choiceImg.src;
      triggerImg.srcset=choiceImg.srcset||'';
      triggerImg.alt=button.dataset.optionValue||'';
    }
  };

  const setColorPendingState=(pending)=>{
    colorSelectionPending=!!pending;
    root.classList.toggle('is-color-selection-pending',colorSelectionPending);
    const notifyAnchor=root.querySelector('[data-notify-me-anchor]');
    if(colorSelectionPending){
      if(addBtn){addBtn.disabled=true;addBtn.hidden=false;}
      if(sticky)sticky.hidden=true;
      if(notifyAnchor)notifyAnchor.hidden=true;
      if(stockEl)stockEl.textContent=stockEl.dataset.chooseColor||'';
    }
  };

  const scrollGalleryToMedia=id=>{
    if(!id||!gallery)return;
    const media=root.querySelector(`[data-media-id="${id}"]`);
    if(!media)return;
    root.querySelectorAll('[data-media-id]').forEach(m=>m.classList.remove('is-active'));
    media.classList.add('is-active');
    root.querySelectorAll('[data-thumb-media-id]').forEach(t=>t.classList.toggle('is-active',String(t.dataset.thumbMediaId)===String(id)));
    gallery.scrollTo({left:Math.max(0,media.offsetLeft-gallery.offsetLeft),behavior:'smooth'});
    const thumb=root.querySelector(`[data-thumb-media-id="${id}"]`);
    thumb?.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
  };

  const updateVariant=()=>{
    if(colorSelectionPending){setColorPendingState(true);return;}
    const found=variantForSelection();
    if(!found)return;
    current=found;
    clearFormError();
    setColorPendingState(false);
    setVariantInput(found);
    if(priceEl)priceEl.textContent=money(found.price);
    if(compareEl){
      if(found.compare_at_price&&found.compare_at_price>found.price){
        compareEl.hidden=false;
        compareEl.textContent=money(found.compare_at_price);
      }else{
        compareEl.hidden=true;
        compareEl.textContent='';
      }
    }
    const limit=stockLimit(found);
    if(stockEl){
      stockEl.textContent=!found.available?(stockEl.dataset.soldOut||'Esaurito'):(Number.isFinite(limit)?`${limit} ${root.dataset.stockCountLabel||'disponibili'}`:(stockEl.dataset.inStock||'Disponibile'));
    }
    const notifyAnchor=root.querySelector('[data-notify-me-anchor]');
    if(addBtn){
      addBtn.disabled=!found.available;
      addBtn.hidden=!found.available;
    }
    if(addLabel)addLabel.textContent=(addLabel.dataset.add||'Aggiungi al carrello');
    if(notifyAnchor)notifyAnchor.hidden=!!found.available;
    if(sticky&&!found.available)sticky.hidden=true;
    if(found.featured_media_id)scrollGalleryToMedia(found.featured_media_id);
    const u=new URL(location.href);
    u.searchParams.set('variant',found.id);
    history.replaceState({},'',u);
    try{
      document.dispatchEvent(new CustomEvent('variant:change',{detail:{variant:found}}));
      document.dispatchEvent(new CustomEvent('variantChanged',{detail:{variant:found}}));
    }catch(e){}
    /* Some app listeners rewrite product-form controls after variant events. */
    setVariantInput(found);
    requestAnimationFrame(()=>setVariantInput(current));
    updateTotal();
  };

  const restoreGalleryImages=()=>{
    root.querySelectorAll('[data-media-id] img[data-kjhs-original-src]').forEach(img=>{
      img.src=img.dataset.kjhsOriginalSrc;
      if(img.dataset.kjhsOriginalSrcset)img.srcset=img.dataset.kjhsOriginalSrcset;
      else img.removeAttribute('srcset');
      img.alt=img.dataset.kjhsOriginalAlt||'';
    });
    root.querySelectorAll('[data-media-zoom][data-kjhs-original-full-src]').forEach(zoom=>{
      zoom.dataset.mediaFullSrc=zoom.dataset.kjhsOriginalFullSrc;
      zoom.dataset.mediaAlt=zoom.dataset.kjhsOriginalAlt||'';
    });
  };

  const showSelectedColorImage=button=>{
    if(!button?.matches('[data-color-choice]'))return;
    const mediaId=button.dataset.colorMediaId;
    if(mediaId&&root.querySelector(`[data-media-id="${mediaId}"]`)){
      restoreGalleryImages();
      scrollGalleryToMedia(mediaId);
      return;
    }

    // Fallback: if Shopify exposes the colour image but it isn't present in the
    // rendered gallery, replace the currently active main image with it.
    const imageSrc=button.dataset.colorImageSrc;
    if(!imageSrc)return;
    const activeMedia=root.querySelector('[data-media-id].is-active')||root.querySelector('[data-media-id]');
    const img=activeMedia?.querySelector('img');
    const zoom=activeMedia?.querySelector('[data-media-zoom]');
    if(img){
      if(!img.dataset.kjhsOriginalSrc){
        img.dataset.kjhsOriginalSrc=img.getAttribute('src')||img.src;
        img.dataset.kjhsOriginalSrcset=img.getAttribute('srcset')||'';
        img.dataset.kjhsOriginalAlt=img.alt||'';
      }
      img.src=imageSrc;
      img.removeAttribute('srcset');
      img.alt=button.dataset.colorImageAlt||button.dataset.optionValue||img.alt||'';
    }
    if(zoom){
      if(!zoom.dataset.kjhsOriginalFullSrc){
        zoom.dataset.kjhsOriginalFullSrc=zoom.dataset.mediaFullSrc||'';
        zoom.dataset.kjhsOriginalAlt=zoom.dataset.mediaAlt||'';
      }
      zoom.dataset.mediaFullSrc=button.dataset.colorImageFullSrc||imageSrc;
      zoom.dataset.mediaAlt=button.dataset.colorImageAlt||button.dataset.optionValue||'';
    }
  };

  root.querySelectorAll('.variant-button').forEach(b=>b.addEventListener('click',()=>{
    if(b.disabled)return;
    const isColorChoice=b.matches('[data-color-choice]');
    const fieldset=b.closest('.product-option');
    const p=Number(b.dataset.optionPosition)-1;
    selected[p]=b.dataset.optionValue;
    if(isColorChoice)colorSelectionPending=false;
    fieldset?.querySelectorAll('.variant-button').forEach(x=>{
      x.classList.remove('is-selected');
      x.setAttribute('aria-pressed','false');
    });
    b.classList.add('is-selected');
    b.setAttribute('aria-pressed','true');
    updateColorSummary(b);

    // Close immediately after the tap. This happens before any variant/media
    // update, so a later storefront error can never leave the picker open.
    if(isColorChoice){
      closeColorPicker(fieldset);
      showSelectedColorImage(b);
    }

    updateVariant();
  }));

  root.querySelectorAll('[data-option-select]').forEach(sel=>sel.addEventListener('change',()=>{
    const p=Number(sel.dataset.optionPosition)-1;
    selected[p]=sel.value;
    updateVariant();
  }));

  root.querySelectorAll('[data-bundle-qty]').forEach(b=>b.addEventListener('click',()=>{
    if(b.disabled||!qtyInput)return;
    qtyInput.value=Number(b.dataset.bundleQty);
    updateTotal();
  }));
  root.querySelector('[data-bogo-set-three]')?.addEventListener('click',()=>{
    if(!qtyInput)return;
    const limit=remainingStock(current);
    if(Number.isFinite(limit)&&limit<3)return;
    qtyInput.value=3;
    updateTotal();
    qtyInput.focus({preventScroll:true});
  });
  qtyInput?.addEventListener('input',updateTotal);
  qtyMinusBtn?.addEventListener('click',()=>{qtyInput.value=Math.max(1,Number(qtyInput.value||1)-1);updateTotal()});
  qtyPlusBtn?.addEventListener('click',()=>{const limit=remainingStock(current);if(Number.isFinite(limit)&&limit<=0)return;qtyInput.value=Math.min(Number(qtyInput.value||1)+1,Number.isFinite(limit)?limit:999);updateTotal()});

  root.querySelectorAll('[data-thumb-media-id]').forEach(t=>t.addEventListener('click',()=>scrollGalleryToMedia(t.dataset.thumbMediaId)));

  const lightbox=root.querySelector('[data-product-lightbox]');
  const lightboxImage=lightbox?.querySelector('[data-lightbox-image]');
  const zoomButtons=[...root.querySelectorAll('[data-media-zoom]')];
  let lightboxIndex=0;
  const showLightboxIndex=index=>{
    if(!lightbox||!lightboxImage||!zoomButtons.length)return;
    lightboxIndex=(index+zoomButtons.length)%zoomButtons.length;
    const source=zoomButtons[lightboxIndex];
    lightboxImage.src=source.dataset.mediaFullSrc||source.querySelector('img')?.currentSrc||source.querySelector('img')?.src||'';
    lightboxImage.alt=source.dataset.mediaAlt||source.querySelector('img')?.alt||'';
  };
  const openLightbox=index=>{
    if(!lightbox)return;
    showLightboxIndex(index);
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden','false');
    document.body.classList.add('product-lightbox-open');
    setTimeout(()=>lightbox.querySelector('[data-lightbox-close]')?.focus(),30);
  };
  const closeLightbox=()=>{
    if(!lightbox)return;
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden','true');
    document.body.classList.remove('product-lightbox-open');
  };
  zoomButtons.forEach((button,index)=>button.addEventListener('click',()=>openLightbox(index)));
  lightbox?.querySelectorAll('[data-lightbox-close]').forEach(button=>button.addEventListener('click',closeLightbox));
  lightbox?.querySelector('[data-lightbox-prev]')?.addEventListener('click',()=>showLightboxIndex(lightboxIndex-1));
  lightbox?.querySelector('[data-lightbox-next]')?.addEventListener('click',()=>showLightboxIndex(lightboxIndex+1));

  let galleryScrollTimer;
  gallery?.addEventListener('scroll',()=>{
    clearTimeout(galleryScrollTimer);
    galleryScrollTimer=setTimeout(()=>{
      const media=[...root.querySelectorAll('[data-media-id]')];
      if(!media.length)return;
      const left=gallery.scrollLeft;
      const nearest=media.reduce((best,item)=>Math.abs(item.offsetLeft-gallery.offsetLeft-left)<Math.abs(best.offsetLeft-gallery.offsetLeft-left)?item:best,media[0]);
      root.querySelectorAll('[data-media-id]').forEach(m=>m.classList.toggle('is-active',m===nearest));
      root.querySelectorAll('[data-thumb-media-id]').forEach(t=>t.classList.toggle('is-active',String(t.dataset.thumbMediaId)===String(nearest.dataset.mediaId)));
    },80);
  },{passive:true});

  stickySubmit?.addEventListener('click',()=>{if(!colorSelectionPending)form?.requestSubmit()});
  if(sticky&&addBtn){
    const io=new IntersectionObserver(entries=>{const e=entries[0];sticky.hidden=e.isIntersecting||!current.available||colorSelectionPending},{threshold:.05});
    io.observe(addBtn);
  }
  form?.addEventListener('submit',async event=>{
    event.preventDefault();
    if(colorSelectionPending){setColorPendingState(true);root.querySelector('[data-color-picker-open]')?.focus();return;}
    const resolved=synchronizeVariantId();
    if(!resolved?.available||!idInput?.value){
      showFormError(addBtn?.dataset.errorLabel);
      return;
    }

    const defaultText=addLabel?.dataset.add||addLabel?.textContent||'Aggiungi al carrello';
    let requestedQty=Math.max(1,parseInt(qtyInput?.value||1,10));
    clearFormError();

    try{
      await fetchCartSnapshot(true);
      const limit=remainingStock(resolved);
      if(Number.isFinite(limit)&&limit<=0){
        showFormError(root.dataset.stockCartFullMessage||addBtn?.dataset.errorLabel);
        updateTotal();
        return;
      }
      if(Number.isFinite(limit)&&requestedQty>limit){
        requestedQty=limit;
        if(qtyInput)qtyInput.value=String(limit);
        updateTotal();
        showFormError(stockMessage(root.dataset.stockLimitMessage||addBtn?.dataset.errorLabel,limit));
        return;
      }

      if(addBtn){addBtn.disabled=true;addBtn.classList.add('is-loading')}
      const payload=new FormData(form);
      payload.set('id',idInput.value);
      payload.set('quantity',String(requestedQty));

      const response=await fetch(`${((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/')}cart/add.js`,{
        method:'POST',
        headers:{'Accept':'application/json'},
        body:payload
      });
      if(!response.ok){
        let message='';
        try{const err=await response.json();message=err.description||err.message||''}catch(e){}
        throw new Error(message||'cart-add-failed');
      }
      await response.json();

      const cart=await fetch(`${rootPath}cart.js`,{headers:{'Accept':'application/json'},cache:'no-store'}).then(r=>r.json());
      cartSnapshot=cart;
      document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=String(cart.item_count));
      document.dispatchEvent(new CustomEvent('kjhs:cart-updated',{detail:{cart}}));
      updateTotal();

      const toast=document.querySelector('[data-kjhs-cart-toast]');
      if(toast){
        toast.hidden=false;
        toast.classList.add('is-visible');
        clearTimeout(toast.__kjhsTimer);
        toast.__kjhsTimer=setTimeout(()=>{toast.classList.remove('is-visible');toast.hidden=true},2600);
      }

      if(addLabel)addLabel.textContent=defaultText;
    }catch(error){
      console.warn('[KJHS add to cart]',error);
      if(addLabel)addLabel.textContent=defaultText;
      showFormError(error?.message||addBtn?.dataset.errorLabel);
    }finally{
      if(addBtn)addBtn.classList.remove('is-loading');
      updateTotal();
    }
  });

  function closeColorPicker(fieldset){
    const layer=fieldset?.querySelector('[data-color-picker]');
    const opener=fieldset?.querySelector('[data-color-picker-open]');
    if(!layer)return;
    layer.classList.remove('is-open');
    layer.setAttribute('aria-hidden','true');
    opener?.setAttribute('aria-expanded','false');
    document.body.classList.remove('color-picker-open');
  }

  root.querySelectorAll('.product-option--compact-color').forEach(fieldset=>{
    const opener=fieldset.querySelector('[data-color-picker-open]');
    const layer=fieldset.querySelector('[data-color-picker]');
    const search=fieldset.querySelector('[data-color-search]');
    const count=fieldset.querySelector('[data-color-visible-count]');
    const empty=fieldset.querySelector('[data-color-empty]');
    const choices=[...fieldset.querySelectorAll('[data-color-choice]')];
    const colorImages=choices.map(choice=>choice.querySelector('img[data-color-thumbnail-src]')).filter(Boolean);
    const hydrateChoiceImage=img=>{
      if(!img)return;
      if(!img.getAttribute('src'))img.src=img.dataset.colorThumbnailSrc;
      thumbnailObserver?.unobserve(img);
    };
    const thumbnailObserver='IntersectionObserver' in window
      ?new IntersectionObserver(entries=>entries.forEach(entry=>{
        if(entry.isIntersecting)hydrateChoiceImage(entry.target);
      }),{root:layer?.querySelector('[data-color-list]')||null,rootMargin:'180px'})
      :null;
    if(thumbnailObserver)colorImages.forEach(img=>thumbnailObserver.observe(img));
    const action=fieldset.querySelector('[data-color-trigger-action]');
    if(action&&!action.dataset.changeLabel)action.dataset.changeLabel=action.textContent.replace('→','').trim();
    const open=()=>{
      layer?.classList.add('is-open');
      layer?.setAttribute('aria-hidden','false');
      opener?.setAttribute('aria-expanded','true');
      document.body.classList.add('color-picker-open');
      requestAnimationFrame(()=>{
        if(thumbnailObserver)colorImages.slice(0,18).forEach(hydrateChoiceImage);
        else colorImages.forEach(hydrateChoiceImage);
      });
      setTimeout(()=>search?.focus(),80);
    };
    opener?.addEventListener('click',open);
    fieldset.querySelectorAll('[data-color-picker-close]').forEach(btn=>btn.addEventListener('click',()=>closeColorPicker(fieldset)));
    search?.addEventListener('input',()=>{
      const q=(search.value||'').trim().toLowerCase();
      let visible=0;
      choices.forEach(choice=>{
        const show=!q||(choice.dataset.colorSearchText||'').includes(q);
        choice.hidden=!show;
        if(show)visible++;
      });
      fieldset.querySelectorAll('[data-color-group]').forEach(group=>{
        const hasVisible=[...group.querySelectorAll('[data-color-choice]')].some(choice=>!choice.hidden);
        group.hidden=!hasVisible;
      });
      if(count)count.textContent=String(visible);
      if(empty)empty.hidden=visible!==0;
    });
  });
  document.addEventListener('keydown',e=>{
    if(e.key!=='Escape')return;
    const openLayer=root.querySelector('[data-color-picker].is-open');
    if(openLayer)closeColorPicker(openLayer.closest('.product-option'));
    if(lightbox?.classList.contains('is-open'))closeLightbox();
  });

  if(requiresColorSelection){
    const colorFieldset=root.querySelector('.product-option--compact-color');
    const colorIndex=Number(colorFieldset?.dataset.optionIndex);
    if(hasExplicitVariant&&colorFieldset&&Number.isFinite(colorIndex)){
      const explicit=variants.find(v=>String(v.id)===String(explicitVariantId))||current;
      const value=explicit?.options?.[colorIndex];
      const button=[...colorFieldset.querySelectorAll('[data-color-choice]')].find(b=>b.dataset.optionValue===value);
      if(button){
        selected[colorIndex]=value;
        button.classList.add('is-selected');
        button.setAttribute('aria-pressed','true');
        updateColorSummary(button);
        showSelectedColorImage(button);
      }
      colorSelectionPending=false;
      updateVariant();
    }else{
      setColorPendingState(true);
      updateTotal();
    }
  }else{
    updateVariant();
  }

  fetchCartSnapshot(true).then(()=>updateTotal());
  document.addEventListener('kjhs:cart-updated',event=>{
    if(event.detail?.cart)cartSnapshot=event.detail.cart;
    updateTotal();
  });
}

function initProductExtras(){
  const rootPath=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';

  const refreshCartCount=async()=>{
    try{
      const cart=await fetch(`${rootPath}cart.js`,{headers:{'Accept':'application/json'},cache:'no-store'}).then(r=>r.json());
      document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=String(cart.item_count));
      document.dispatchEvent(new CustomEvent('kjhs:cart-updated',{detail:{cart}}));
      return cart;
    }catch(e){return null}
  };

  const showToast=()=>{
    const toast=document.querySelector('[data-kjhs-cart-toast]');
    if(!toast)return;
    toast.hidden=false;
    toast.classList.add('is-visible');
    clearTimeout(toast.__kjhsTimer);
    toast.__kjhsTimer=setTimeout(()=>{toast.classList.remove('is-visible');toast.hidden=true},2600);
  };

  const addVariant=async(id,trigger)=>{
    if(!id||!trigger||trigger.disabled)return false;
    const reloadCartPage=!!trigger.closest('[data-cart-crosssell]');
    const defaultLabel=trigger.dataset.labelDefault||trigger.textContent.trim();
    const loadingLabel=trigger.dataset.labelLoading||defaultLabel;
    const addedLabel=trigger.dataset.labelAdded||defaultLabel;
    const errorLabel=trigger.dataset.labelError||defaultLabel;
    trigger.disabled=true;
    trigger.classList.add('is-loading');
    trigger.textContent=loadingLabel;
    try{
      const response=await fetch(`${rootPath}cart/add.js`,{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[{id:Number(id),quantity:1}]})
      });
      if(!response.ok){
        let message='';
        try{const error=await response.json();message=error.description||error.message||''}catch(e){}
        throw new Error(message||'cross-sell-add-failed');
      }
      await response.json();
      await refreshCartCount();
      if(reloadCartPage){
        window.location.reload();
        return true;
      }
      trigger.textContent=addedLabel;
      trigger.classList.add('is-added');
      showToast();
      setTimeout(()=>{
        trigger.disabled=false;
        trigger.classList.remove('is-loading','is-added');
        trigger.textContent=defaultLabel;
      },1500);
      return true;
    }catch(e){
      console.warn('[KJHS cross-sell]',e);
      trigger.textContent=errorLabel;
      trigger.classList.remove('is-loading');
      setTimeout(()=>{trigger.disabled=false;trigger.textContent=defaultLabel},2200);
      return false;
    }
  };

  const initCrossSellSection=section=>{
    if(!section||section.dataset.kjhsCrossSellReady==='true')return;
    const cards=section.querySelectorAll('[data-crosssell-card]');
    if(!cards.length)return;
    section.dataset.kjhsCrossSellReady='true';

    cards.forEach(card=>{
      const opener=card.querySelector('[data-crosssell-open]');
      const picker=card.querySelector('[data-crosssell-picker]');
      const closePicker=()=>{
        if(!picker)return;
        picker.hidden=true;
        picker.setAttribute('aria-hidden','true');
        document.body.classList.remove('crosssell-picker-open');
      };
      const openPicker=()=>{
        if(!picker)return;
        picker.hidden=false;
        picker.setAttribute('aria-hidden','false');
        document.body.classList.add('crosssell-picker-open');
        setTimeout(()=>picker.querySelector('[data-crosssell-search]')?.focus(),20);
      };

      opener?.addEventListener('click',openPicker);
      picker?.querySelectorAll('[data-crosssell-close]').forEach(btn=>btn.addEventListener('click',closePicker));

      const search=picker?.querySelector('[data-crosssell-search]');
      search?.addEventListener('input',()=>{
        const query=search.value.trim().toLowerCase();
        picker.querySelectorAll('[data-crosssell-variant-add]').forEach(option=>{
          option.hidden=!!query&&!String(option.dataset.search||'').includes(query);
        });
      });

      picker?.querySelectorAll('[data-crosssell-variant-add]').forEach(option=>{
        if(option.dataset.kjhsReady==='true')return;
        option.dataset.kjhsReady='true';
        option.addEventListener('click',async()=>{
          const original=option.innerHTML;
          const originallyDisabled=option.disabled;
          const ok=await addVariant(option.dataset.variantId,option);
          if(ok){
            closePicker();
            if(opener){
              const label=opener.dataset.labelAdded||opener.textContent;
              const defaultLabel=opener.dataset.labelDefault||opener.textContent;
              opener.textContent=label;
              opener.classList.add('is-added');
              setTimeout(()=>{opener.textContent=defaultLabel;opener.classList.remove('is-added')},1500);
            }
          }
          setTimeout(()=>{
            option.innerHTML=original;
            option.disabled=originallyDisabled;
            option.classList.remove('is-loading','is-added');
          },1550);
        });
      });
    });

    section.querySelectorAll('[data-crosssell-add]').forEach(button=>{
      if(button.dataset.kjhsReady==='true')return;
      button.dataset.kjhsReady='true';
      button.addEventListener('click',()=>addVariant(button.dataset.variantId,button));
    });
  };

  const escapeHTML=value=>String(value??'').replace(/[&<>"]/g,ch=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[ch]));
  const imageURL=image=>{
    if(!image)return '';
    if(typeof image==='string')return image;
    return image.src||image.url||'';
  };
  const money=c=>{
    const currency=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR';
    try{return new Intl.NumberFormat(document.documentElement.lang||'it-IT',{style:'currency',currency}).format(Number(c||0)/100)}
    catch(e){return (Number(c||0)/100).toFixed(2)+' €'}
  };

  const buildCrossSellCard=(product,index,section,intent='complementary')=>{
    const role='recommended';
    const roleLabel=section.dataset.roleRecommended||'Recommended';
    const variants=Array.isArray(product.variants)?product.variants:[];
    const availableVariants=variants.filter(v=>v.available);
    const selectedVariant=availableVariants[0]||variants[0]||null;
    const hasVariantChoice=variants.length>1;
    const pickerLabel=section.dataset.chooseOption||'Choose option';
    const featured=imageURL(product.featured_image)||(Array.isArray(product.images)?imageURL(product.images[0]):'');
    const productURL=product.url||rootPath;
    const soldOut=section.dataset.soldOut||'Sold out';
    const quickAdd=section.dataset.quickAdd||'+ Add';
    const adding=section.dataset.adding||quickAdd;
    const added=section.dataset.added||quickAdd;
    const error=section.dataset.error||quickAdd;
    const close=section.dataset.close||'Close';
    const searchLabel=section.dataset.searchVariants||'Search';

    const variantOptions=variants.map(v=>{
      const vImage=imageURL(v.featured_image)||featured;
      const disabled=v.available?'':' disabled data-original-disabled="true"';
      const plus=v.available?'+':'×';
      return `<button type="button" class="crosssell-picker__option" data-crosssell-variant-add data-variant-id="${escapeHTML(v.id)}" data-search="${escapeHTML(String(v.title||'').toLowerCase())}" data-label-loading="${escapeHTML(adding)}"${disabled}>
        <span class="crosssell-picker__thumb">${vImage?`<img src="${escapeHTML(vImage)}" loading="lazy" alt="${escapeHTML(v.title||product.title||'')}">`:''}</span>
        <span class="crosssell-picker__option-copy"><strong>${escapeHTML(v.public_title||v.title||'')}</strong><small>${money(v.price)}</small></span>
        <span class="crosssell-picker__plus" aria-hidden="true">${plus}</span>
      </button>`;
    }).join('');

    const action=!product.available||!selectedVariant
      ? `<button type="button" class="crosssell-role-card__action" disabled>${escapeHTML(soldOut)}</button>`
      : hasVariantChoice
        ? `<button type="button" class="crosssell-role-card__action" data-crosssell-open data-label-default="${escapeHTML(pickerLabel)}" data-label-added="${escapeHTML(added)}">${escapeHTML(pickerLabel)}</button>`
        : `<button type="button" class="crosssell-role-card__action" data-crosssell-add data-variant-id="${escapeHTML(selectedVariant.id)}" data-label-default="${escapeHTML(quickAdd)}" data-label-loading="${escapeHTML(adding)}" data-label-added="${escapeHTML(added)}" data-label-error="${escapeHTML(error)}">${escapeHTML(quickAdd)}</button>`;

    const picker=hasVariantChoice?`<div class="crosssell-picker" data-crosssell-picker hidden aria-hidden="true">
      <button class="crosssell-picker__backdrop" type="button" data-crosssell-close aria-label="${escapeHTML(close)}"></button>
      <div class="crosssell-picker__panel" role="dialog" aria-modal="true" aria-label="${escapeHTML(pickerLabel)}">
        <div class="crosssell-picker__head"><div><span class="crosssell-picker__role">${escapeHTML(roleLabel)}</span><strong>${escapeHTML(pickerLabel)}</strong></div><button type="button" class="crosssell-picker__close" data-crosssell-close aria-label="${escapeHTML(close)}">×</button></div>
        ${variants.length>5?`<label class="crosssell-picker__search"><span class="visually-hidden">${escapeHTML(searchLabel)}</span><input type="search" placeholder="${escapeHTML(searchLabel)}" data-crosssell-search autocomplete="off"></label>`:''}
        <div class="crosssell-picker__options" data-crosssell-options>${variantOptions}</div>
      </div>
    </div>`:'';

    return `<article class="crosssell-role-card" data-crosssell-card data-crosssell-role="${role}">
      <a class="crosssell-role-card__media" href="${escapeHTML(productURL)}" aria-label="${escapeHTML(product.title||'')}">${featured?`<img src="${escapeHTML(featured)}" loading="lazy" alt="${escapeHTML(product.title||'')}">`:''}</a>
      <div class="crosssell-role-card__body"><a class="crosssell-role-card__title" href="${escapeHTML(productURL)}">${escapeHTML(product.title||'')}</a><strong class="crosssell-role-card__price">${selectedVariant?money(selectedVariant.price):''}</strong>${action}</div>
      ${picker}
    </article>`;
  };

  document.querySelectorAll('[data-kjhs-complementary]').forEach(async section=>{
    if(section.dataset.kjhsRecommendationsLoading==='true'||section.dataset.kjhsRecommendationsLoaded==='true')return;
    section.dataset.kjhsRecommendationsLoading='true';
    const complementaryUrl=section.dataset.recommendationsComplementaryUrl;
    const relatedUrl=section.dataset.recommendationsRelatedUrl;
    const grid=section.querySelector('[data-crosssell-grid]');
    if(!grid){section.remove();return;}

    const fetchProducts=async url=>{
      if(!url)return [];
      const response=await fetch(url,{headers:{'Accept':'application/json'},cache:'no-store'});
      if(!response.ok)throw new Error(`recommendations-${response.status}`);
      const payload=await response.json();
      return Array.isArray(payload.products)?payload.products:[];
    };

    try{
      let complementaryProducts=[];
      let relatedProducts=[];

      try{complementaryProducts=await fetchProducts(complementaryUrl)}catch(error){console.warn('[KJHS complementary recommendations]',error)}

      if(complementaryProducts.length<3){
        try{relatedProducts=await fetchProducts(relatedUrl)}catch(error){console.warn('[KJHS related recommendations]',error)}
      }

      const seen=new Set();
      const recommendations=[];
      const appendProducts=(products,intent)=>{
        products.forEach(product=>{
          if(recommendations.length>=3)return;
          const key=String(product.id||product.handle||product.url||'');
          if(!key||seen.has(key))return;
          seen.add(key);
          recommendations.push({product,intent});
        });
      };

      appendProducts(complementaryProducts,'complementary');
      appendProducts(relatedProducts,'related');

      if(!recommendations.length){section.remove();return;}

      section.dataset.recommendationIntent=complementaryProducts.length?'complementary-first':'related';
      grid.innerHTML=recommendations.map((item,index)=>buildCrossSellCard(item.product,index,section,item.intent)).join('');
      section.dataset.kjhsRecommendationsLoaded='true';
      section.dataset.kjhsRecommendationsLoading='false';
      section.dataset.kjhsCrossSellReady='false';
      initCrossSellSection(section);
    }catch(error){
      console.warn('[KJHS product recommendations]',error);
      section.remove();
    }
  });

  document.querySelectorAll('[data-cart-random-accessories]').forEach(section=>{
    if(section.dataset.kjhsRandomAccessoriesReady==='true')return;
    const grid=section.querySelector('.crosssell-role-grid');
    const cards=[...section.querySelectorAll('[data-random-accessory-card]')];
    if(!grid||!cards.length){section.remove();return;}

    const shuffle=list=>{
      const copy=[...list];
      for(let i=copy.length-1;i>0;i--){
        const j=Math.floor(Math.random()*(i+1));
        [copy[i],copy[j]]=[copy[j],copy[i]];
      }
      return copy;
    };

    const maxVisible=Math.min(4,Math.max(1,Number(section.dataset.randomAccessoryMax||4)));
    let previous=[];
    try{previous=JSON.parse(sessionStorage.getItem('kjhsCartAccessoryLast')||'[]')}catch(e){previous=[]}
    if(!Array.isArray(previous))previous=[];

    const choose=(list,count)=>{
      const fresh=shuffle(list.filter(card=>!previous.includes(card.dataset.randomAccessoryHandle||'')));
      const repeats=shuffle(list.filter(card=>previous.includes(card.dataset.randomAccessoryHandle||'')));
      return [...fresh,...repeats].slice(0,count);
    };

    const headwear=cards.filter(card=>card.dataset.randomAccessoryGroup==='headwear');
    const accessories=cards.filter(card=>card.dataset.randomAccessoryGroup!=='headwear');
    const selected=[];

    // Cart cross-sell is strictly capped at 4 visible cards: 1 Bonnet + 3 accessories.
    selected.push(...choose(headwear,1));
    selected.push(...choose(accessories,Math.min(3,Math.max(0,maxVisible-selected.length))));

    const selectedSet=new Set(selected.slice(0,4));
    cards.forEach(card=>{
      if(selectedSet.has(card)){
        card.hidden=false;
        grid.appendChild(card);
      }else{
        card.remove();
      }
    });

    try{
      sessionStorage.setItem('kjhsCartAccessoryLast',JSON.stringify(selected.map(card=>card.dataset.randomAccessoryHandle||'').filter(Boolean)));
    }catch(e){}
    section.dataset.kjhsRandomAccessoriesReady='true';
  });

  document.querySelectorAll('[data-kjhs-product-extras][data-extras-mode="cross-sell"]').forEach(initCrossSellSection);

  if(!window.__kjhsCrossSellEscape){
    window.__kjhsCrossSellEscape=true;
    document.addEventListener('keydown',event=>{
      if(event.key!=='Escape')return;
      document.querySelectorAll('[data-crosssell-picker]:not([hidden])').forEach(picker=>{
        picker.hidden=true;
        picker.setAttribute('aria-hidden','true');
      });
      document.body.classList.remove('crosssell-picker-open');
    });
  }
}

function initManualBundles(){
  const currency=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR';
  const locale=document.documentElement.lang||'it-IT';
  const money=c=>{try{return new Intl.NumberFormat(locale,{style:'currency',currency}).format(c/100)}catch(e){return (c/100).toFixed(2)+' €'}};
  const rootPath=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';

  const refreshCart=async()=>{
    try{
      const cart=await fetch(`${rootPath}cart.js`,{headers:{'Accept':'application/json'},cache:'no-store'}).then(r=>r.json());
      document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=String(cart.item_count));
      document.dispatchEvent(new CustomEvent('kjhs:cart-updated',{detail:{cart}}));
      return cart;
    }catch(e){return null}
  };

  const showToast=()=>{
    const toast=document.querySelector('[data-kjhs-cart-toast]');
    if(!toast)return;
    toast.hidden=false;
    toast.classList.add('is-visible');
    clearTimeout(toast.__kjhsTimer);
    toast.__kjhsTimer=setTimeout(()=>{toast.classList.remove('is-visible');toast.hidden=true},2600);
  };

  document.querySelectorAll('[data-manual-bundle]').forEach(bundle=>{
    if(bundle.dataset.kjhsBundleReady==='true')return;
    bundle.dataset.kjhsBundleReady='true';

    const total=bundle.querySelector('[data-bundle-total]');
    const original=bundle.querySelector('[data-bundle-original]');
    const discount=bundle.querySelector('[data-shopify-bundle-discount]');
    const button=bundle.querySelector('[data-manual-bundle-add]');
    const label=bundle.querySelector('[data-bundle-add-label]');
    const loader=bundle.querySelector('[data-shopify-bundle-loader]');
    const bundleHandle=(bundle.dataset.bundleHandle||'').trim();
    if(!button)return;

    let control=bundle.querySelector('[data-shopify-bundle-variant]');

    const selectedData=()=>{
      if(!control)return {id:'',price:0,compare:0,available:false};
      if(control.tagName==='SELECT'){
        const option=control.selectedOptions[0];
        return {
          id:control.value,
          price:Number(option?.dataset.price||0),
          compare:Number(option?.dataset.comparePrice||0),
          available:!!option&&!option.disabled
        };
      }
      return {
        id:control.value,
        price:Number(control.dataset.price||0),
        compare:Number(control.dataset.comparePrice||0),
        available:!control.disabled
      };
    };

    const render=()=>{
      const state=selectedData();
      if(total)total.textContent=state.price>0?money(state.price):'—';
      const hasCompare=state.compare>state.price&&state.price>0;
      if(original){
        original.hidden=!hasCompare;
        original.textContent=hasCompare?money(state.compare):'';
      }
      if(discount){
        const fixedDiscount=Number(discount.dataset.fixedDiscount||0);
        if(fixedDiscount>0){
          discount.hidden=false;
          discount.textContent=`-${fixedDiscount}%`;
        }else{
          discount.hidden=!hasCompare;
          discount.textContent=hasCompare?`-${Math.round((state.compare-state.price)*100/state.compare)}%`:'';
        }
      }
      button.disabled=!state.available||!state.id;
    };

    const bindControl=nextControl=>{
      control=nextControl;
      if(!control)return;
      control.addEventListener('change',render);
      render();
    };

    const loadBundleByHandle=async()=>{
      if(control||!bundleHandle)return;
      try{
        const response=await fetch(`${rootPath}products/${encodeURIComponent(bundleHandle)}.js`,{
          headers:{'Accept':'application/json'},
          cache:'no-store'
        });
        if(!response.ok)throw new Error(`bundle-product-${response.status}`);
        const product=await response.json();
        const variants=Array.isArray(product.variants)?product.variants:[];
        if(!variants.length)throw new Error('bundle-no-variants');

        let nextControl;
        if(variants.length>1){
          const wrap=document.createElement('label');
          wrap.className='manual-bundle-real-variant';
          const caption=document.createElement('span');
          caption.textContent=bundle.dataset.chooseOption||'Choose option';
          const select=document.createElement('select');
          select.setAttribute('data-shopify-bundle-variant','');
          variants.forEach(variant=>{
            const option=document.createElement('option');
            option.value=String(variant.id);
            option.dataset.price=String(variant.price||0);
            option.dataset.comparePrice=String(variant.compare_at_price||0);
            option.disabled=!variant.available;
            option.textContent=`${variant.title} · ${money(Number(variant.price||0))}${variant.available?'':' · Esaurito'}`;
            select.appendChild(option);
          });
          const firstAvailable=variants.find(v=>v.available);
          if(firstAvailable)select.value=String(firstAvailable.id);
          wrap.append(caption,select);
          if(loader)loader.replaceWith(wrap); else bundle.insertBefore(wrap,bundle.querySelector('.manual-bundle-card__footer'));
          nextControl=select;
        }else{
          const variant=variants[0];
          const input=document.createElement('input');
          input.type='hidden';
          input.value=String(variant.id);
          input.dataset.shopifyBundleVariant='';
          input.dataset.price=String(variant.price||0);
          input.dataset.comparePrice=String(variant.compare_at_price||0);
          input.disabled=!variant.available;
          if(loader)loader.replaceWith(input); else bundle.appendChild(input);
          nextControl=input;
        }
        bindControl(nextControl);
      }catch(error){
        console.warn('[KJHS Shopify bundle load]',error);
        if(loader)loader.remove();
        button.disabled=true;
      }
    };

    if(control)bindControl(control); else loadBundleByHandle();

    button.addEventListener('click',async()=>{
      const state=selectedData();
      if(button.disabled||!state.available||!state.id)return;
      const defaultText=button.dataset.labelDefault||label?.textContent||'Add kit to cart';
      const loadingText=button.dataset.labelLoading||defaultText;
      const errorText=button.dataset.labelError||defaultText;
      const addedText=button.dataset.labelAdded||defaultText;
      button.disabled=true;
      button.classList.add('is-loading');
      if(label)label.textContent=loadingText;
      try{
        const response=await fetch(`${rootPath}cart/add.js`,{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[{id:Number(state.id),quantity:1}]})
        });
        if(!response.ok){
          let message='';
          try{const error=await response.json();message=error.description||error.message||''}catch(e){}
          throw new Error(message||'shopify-bundle-add-failed');
        }
        await response.json();
        await refreshCart();
        if(label)label.textContent=addedText;
        button.classList.add('is-added');
        showToast();
        setTimeout(()=>{
          button.classList.remove('is-loading','is-added');
          if(label)label.textContent=defaultText;
          render();
        },1500);
      }catch(error){
        console.warn('[KJHS Shopify bundle]',error);
        button.classList.remove('is-loading');
        if(label)label.textContent=errorText;
        setTimeout(()=>{
          if(label)label.textContent=defaultText;
          render();
        },2200);
      }
    });
  });

}

function initCartVolumeProgress(){
  const blocks=[...document.querySelectorAll('[data-cart-volume-progress]')];
  if(!blocks.length)return;

  const getQtyForProduct=id=>[...document.querySelectorAll(`[data-cart-qty][data-product-id="${id}"]`)]
    .reduce((sum,input)=>sum+Math.max(0,parseInt(input.value||0,10)||0),0);

  const rulesFor=block=>{
    const mode=block.dataset.volumeMode||'future';
    const scheme=block.dataset.tierScheme||'standard';
    if(scheme==='hook')return [{q:1,d:0},{q:2,d:5},{q:3,d:10}];
    if(scheme==='mini-elastics')return [{q:1,d:0},{q:5,d:10},{q:10,d:20},{q:20,d:30},{q:100,d:50}];
    if(scheme==='accessory')return [{q:1,d:0},{q:3,d:10},{q:5,d:20},{q:10,d:35}];
    if(mode==='current')return [{q:1,d:0},{q:10,d:10}];
    return scheme==='maxi'
      ? [{q:1,d:0},{q:2,d:5},{q:3,d:10},{q:5,d:15}]
      : [{q:1,d:0},{q:3,d:5},{q:5,d:10},{q:10,d:20}];
  };

  const interpolate=(template,values)=>Object.entries(values).reduce((out,[key,val])=>out.replaceAll(`{{ ${key} }}`,String(val)).replaceAll(`{{${key}}}`,String(val)),template||'');

  const render=block=>{
    const id=block.dataset.productId;
    const title=block.dataset.productTitle||'';
    const qty=getQtyForProduct(id);
    const rules=rulesFor(block);
    const max=rules[rules.length-1];
    let current=rules[0];
    rules.forEach(rule=>{if(qty>=rule.q)current=rule});
    const next=rules.find(rule=>rule.q>qty);
    const qtyEl=block.querySelector('[data-cart-volume-qty]');
    const fill=block.querySelector('[data-cart-volume-fill]');
    const msg=block.querySelector('[data-cart-volume-message]');
    if(qtyEl)qtyEl.textContent=String(qty);
    if(fill)fill.style.width=`${Math.max(0,Math.min(100,qty/max.q*100))}%`;
    if(msg){
      if(next){
        const remaining=Math.max(0,next.q-qty);
        if(current.d>0){
          msg.textContent=interpolate(block.dataset.templateNext,{current_discount:current.d,remaining,product:title,next_discount:next.d});
        }else{
          msg.textContent=interpolate(block.dataset.templateUnlock,{qty,product:title,remaining,next_discount:next.d});
        }
      }else{
        msg.textContent=interpolate(block.dataset.templateBest,{current_discount:current.d});
      }
    }
  };

  blocks.forEach(render);
  document.querySelectorAll('[data-cart-qty]').forEach(input=>input.addEventListener('input',()=>{
    blocks.filter(block=>block.dataset.productId===input.dataset.productId).forEach(render);
  }));
}


function initCartInventoryLimits(){
  const inputs=[...document.querySelectorAll('[data-cart-qty][data-stock-max]')];
  if(!inputs.length)return;

  const clamp=input=>{
    const max=Math.max(0,Number(input.dataset.stockMax||input.max||0));
    let value=Math.max(0,parseInt(input.value||0,10)||0);
    if(Number.isFinite(max))value=Math.min(value,max);
    input.value=String(value);
  };

  inputs.forEach(input=>{
    if(input.dataset.kjhsStockLimitReady==='true')return;
    input.dataset.kjhsStockLimitReady='true';
    input.addEventListener('input',()=>clamp(input));
    input.addEventListener('change',()=>clamp(input));
  });

  const form=inputs[0]?.closest('form');
  if(form&&form.dataset.kjhsStockLimitReady!=='true'){
    form.dataset.kjhsStockLimitReady='true';
    form.addEventListener('submit',()=>inputs.forEach(clamp),true);
  }
}


function initInvoiceRequest(){
  document.querySelectorAll('[data-kjhs-invoice]').forEach(root=>{
    if(root.dataset.kjhsInvoiceReady==='true')return;
    root.dataset.kjhsInvoiceReady='true';

    const form=root.closest('form');
    const toggle=root.querySelector('[data-invoice-toggle]');
    const fields=root.querySelector('[data-invoice-fields]');
    const businessFields=root.querySelector('[data-invoice-business-fields]');
    const italyFields=root.querySelector('[data-invoice-italy-fields]');
    const taxFields=root.querySelector('[data-invoice-tax-fields]');
    const taxRequiredMark=root.querySelector('[data-tax-required-mark]');
    const vatRequiredMark=root.querySelector('[data-vat-required-mark]');
    const vatInput=root.querySelector('[data-invoice-field="vat"]');
    const taxLabel=root.querySelector('[data-tax-label]');
    const taxItalyHelp=root.querySelector('[data-tax-italy-help]');
    const taxInput=root.querySelector('[data-invoice-field="tax_id"]');
    const countrySelect=root.querySelector('[data-invoice-country]');
    const countryNameInput=root.querySelector('[data-invoice-country-name]');
    const countryCodeInput=root.querySelector('[data-invoice-country-code]');
    const requestedInput=root.querySelector('[data-invoice-attribute="Invoice Requested"]');
    const typeInputs=[...root.querySelectorAll('[data-invoice-type]')];
    const summary=root.querySelector('[data-invoice-error-summary]');
    const saveUrl=root.dataset.saveUrl||`${((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/')}cart/update.js`;
    const rootPath=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
    const bolloVariantId=root.dataset.bolloVariantId||'';
    const bolloError=root.dataset.errorBollo||'Unable to update the invoice stamp duty. Please try again.';
    let saveTimer=null;
    let saveChain=Promise.resolve();
    let checkoutSaving=false;
    let checkoutReady=false;
    let bolloSyncChain=Promise.resolve();

    const currentType=()=>typeInputs.find(input=>input.checked)?.value||'';
    const currentCountry=()=>countrySelect?.value||countryCodeInput?.value||'';
    const isItaly=()=>currentCountry()==='IT';
    const isBusiness=()=>currentType()==='Business';

    const setCountryAttributes=()=>{
      if(!countrySelect)return;
      const option=countrySelect.options[countrySelect.selectedIndex];
      if(countryCodeInput)countryCodeInput.value=toggle?.checked?(countrySelect.value||''):'';
      if(countryNameInput)countryNameInput.value=toggle?.checked?(option?.dataset.countryName||option?.textContent?.trim()||''):'';
    };

    const clearError=key=>{
      const error=root.querySelector(`[data-error-for="${key}"]`);
      const field=key==='customer_type'?root.querySelector('[data-invoice-customer-type-field]'):root.querySelector(`[data-invoice-field="${key}"]`);
      if(error){error.hidden=true;error.textContent=''}
      field?.removeAttribute('aria-invalid');
      field?.closest('.kjhs-invoice__field')?.classList.remove('has-error');
      if(key==='customer_type')root.querySelector('[data-invoice-customer-type-field]')?.classList.remove('has-error');
    };

    const showError=(key,message)=>{
      const error=root.querySelector(`[data-error-for="${key}"]`);
      const field=key==='customer_type'?null:root.querySelector(`[data-invoice-field="${key}"]`);
      if(error){error.textContent=message;error.hidden=false}
      if(field){field.setAttribute('aria-invalid','true');field.closest('.kjhs-invoice__field')?.classList.add('has-error')}
      if(key==='customer_type')root.querySelector('[data-invoice-customer-type-field]')?.classList.add('has-error');
    };

    const updateVisibility=()=>{
      const active=!!toggle?.checked;
      if(fields)fields.hidden=!active;
      if(requestedInput)requestedInput.value=active?'YES':'NO';
      if(businessFields)businessFields.hidden=!isBusiness();
      if(italyFields)italyFields.hidden=!isItaly();
      if(taxFields)taxFields.hidden=!(isItaly()||isBusiness());
      if(taxRequiredMark)taxRequiredMark.hidden=!(isItaly()&&!isBusiness());
      if(vatRequiredMark)vatRequiredMark.hidden=!isBusiness();
      if(vatInput)vatInput.setAttribute('aria-required',String(active&&isBusiness()));
      if(taxLabel)taxLabel.textContent=isItaly()?taxLabel.dataset.labelItaly:taxLabel.dataset.labelOther;
      if(taxItalyHelp)taxItalyHelp.hidden=!isItaly();
      if(taxInput){
        if(isItaly())taxInput.value=taxInput.value.trim().toUpperCase();
        taxInput.setAttribute('aria-required',String(active&&isItaly()&&!isBusiness()));
      }
      fields?.querySelectorAll('input,select,textarea').forEach(input=>{
        input.disabled=!active||!!input.closest('[hidden]');
      });
      setCountryAttributes();
    };

    const collectAttributes=()=>{
      setCountryAttributes();
      const attributes={'Invoice Customer Type':''};
      root.querySelectorAll('[name^="attributes["]').forEach(input=>{
        const match=input.name.match(/^attributes\[(.+)\]$/);
        if(!match)return;
        if((input.type==='radio'||input.type==='checkbox')&&!input.checked)return;
        attributes[match[1]]=input.disabled?'':(input.value||'');
      });
      attributes['Invoice Requested']=toggle?.checked?'YES':'NO';
      if(!toggle?.checked){
        [
          'Invoice Customer Type','Invoice Name','Invoice Company','Invoice VAT Number','Invoice Tax ID',
          'Invoice Billing Address','Invoice Postal Code','Invoice City','Invoice State','Invoice Country',
          'Invoice Country Code','Invoice Email','Invoice SDI','Invoice PEC'
        ].forEach(key=>attributes[key]='');
      }
      return attributes;
    };

    const saveAttributes=()=>{
      const attributes=collectAttributes();
      // Keep writes in order so an older autosave cannot overwrite the checkout data.
      saveChain=saveChain.catch(()=>{}).then(async()=>{
        const response=await fetch(saveUrl,{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          credentials:'same-origin',
          body:JSON.stringify({attributes})
        });
        if(!response.ok)throw new Error('Invoice attributes were not saved.');
      });
      return saveChain;
    };

    // Imposta di bollo: una unità solo con fattura richiesta e imponibile
    // del carrello (al netto degli sconti e del bollo stesso) > 77,47 €.
    // Il checkout può ricalcolare spedizione/sconti: il tema non può intercettarli.
    const syncBollo=()=>{
      bolloSyncChain=bolloSyncChain.catch(()=>{}).then(async()=>{
        const cartResponse=await fetch(`${rootPath}cart.js`,{credentials:'same-origin',headers:{'Accept':'application/json'},cache:'no-store'});
        if(!cartResponse.ok)throw new Error(bolloError);
        const cart=await cartResponse.json();
        const bolloItems=(cart.items||[]).filter(item=>String(item.variant_id)===String(bolloVariantId)&&bolloVariantId);
        const bolloAmount=bolloItems.reduce((sum,item)=>sum+Number(item.final_line_price||0),0);
        const baseAmount=Number(cart.total_price||0)-bolloAmount;
        const required=!!toggle?.checked&&baseAmount>7747;
        if(required&&!bolloVariantId)throw new Error(bolloError);
        const qty=bolloItems.reduce((sum,item)=>sum+Number(item.quantity||0),0);
        if((required&&qty===1&&bolloItems.length===1)||(!required&&qty===0))return false;
        const post=async(endpoint,payload)=>{
          const response=await fetch(`${rootPath}cart/${endpoint}.js`,{
            method:'POST',credentials:'same-origin',
            headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify(payload)
          });
          if(!response.ok)throw new Error(bolloError);
        };
        if(required&&!qty){
          await post('add',{id:Number(bolloVariantId),quantity:1});
        }else{
          for(let index=0;index<bolloItems.length;index++){
            const item=bolloItems[index];
            const target=required&&index===0?1:0;
            if(Number(item.quantity)!==target)await post('change',{id:item.key,quantity:target});
          }
        }
        return true;
      });
      return bolloSyncChain;
    };

    const showBolloError=error=>{
      if(summary){
        summary.textContent=error?.message||bolloError;
        summary.hidden=false;
        summary.scrollIntoView({block:'nearest'});
      }
    };

    const syncAfterSave=promise=>{
      promise.then(()=>syncBollo()).then(changed=>{
        if(changed&&!checkoutSaving)window.location.reload();
      }).catch(showBolloError);
    };

    const queueSave=(immediate=false)=>{
      clearTimeout(saveTimer);
      const save=()=>saveAttributes().catch(()=>{});
      if(immediate){save();return}
      saveTimer=setTimeout(save,450);
    };

    const resetInvoiceData=()=>{
      root.querySelectorAll('[name^="attributes["]').forEach(input=>{
        if(input===requestedInput)return;
        if(input.type==='radio'||input.type==='checkbox')input.checked=false;
        else input.value='';
      });
      if(countrySelect){
        const marketCountry=(window.Shopify&&Shopify.country)||countryCodeInput?.defaultValue||'IT';
        const option=[...countrySelect.options].find(o=>o.value===marketCountry);
        if(option)countrySelect.value=option.value;
      }
      if(requestedInput)requestedInput.value='NO';
      if(summary){summary.hidden=true;summary.textContent=''}
      root.querySelectorAll('[data-error-for]').forEach(error=>{error.hidden=true;error.textContent=''})
      root.querySelectorAll('[aria-invalid="true"]').forEach(el=>el.removeAttribute('aria-invalid'));
      root.querySelectorAll('.has-error').forEach(el=>el.classList.remove('has-error'));
      updateVisibility();
      return saveAttributes();
    };

    const validate=()=>{
      if(!toggle?.checked)return true;
      let valid=true;
      let firstInvalid=null;
      const requiredMessage=root.dataset.errorRequired||'Required field.';
      const emailMessage=root.dataset.errorEmail||requiredMessage;
      const checks=[
        ['name',true],['address',true],['postal',true],['city',true],['email',true]
      ];

      clearError('customer_type');
      if(!currentType()){
        showError('customer_type',requiredMessage);valid=false;firstInvalid=root.querySelector('[data-invoice-type]');
      }

      checks.forEach(([key,required])=>{
        clearError(key);
        if(!required)return;
        const input=root.querySelector(`[data-invoice-field="${key}"]`);
        const value=input?.value?.trim()||'';
        if(!value){showError(key,requiredMessage);valid=false;firstInvalid=firstInvalid||input;return}
        if(key==='email'&&input&&!/^\S+@\S+\.\S+$/.test(value)){
          showError(key,emailMessage);valid=false;firstInvalid=firstInvalid||input;
        }
      });

      clearError('company');
      if(isBusiness()){
        const input=root.querySelector('[data-invoice-field="company"]');
        if(!input?.value?.trim()){showError('company',requiredMessage);valid=false;firstInvalid=firstInvalid||input}
      }

      clearError('vat');
      if(isBusiness()&&!vatInput?.value?.trim()){
        showError('vat',requiredMessage);valid=false;firstInvalid=firstInvalid||vatInput;
      }

      clearError('country');
      if(!currentCountry()){
        showError('country',requiredMessage);valid=false;firstInvalid=firstInvalid||countrySelect;
      }

      clearError('tax_id');
      if(isItaly()&&!isBusiness()){
        const input=root.querySelector('[data-invoice-field="tax_id"]');
        if(!input?.value?.trim()){showError('tax_id',requiredMessage);valid=false;firstInvalid=firstInvalid||input}
      }

      if(summary){
        summary.hidden=valid;
        summary.textContent=valid?'':(root.dataset.errorSummary||requiredMessage);
      }
      if(!valid)firstInvalid?.focus({preventScroll:false});
      return valid;
    };

    toggle?.addEventListener('change',()=>{
      if(toggle.checked){
        if(!currentType()&&root.dataset.defaultType){
          const defaultType=typeInputs.find(input=>input.value===root.dataset.defaultType);
          if(defaultType)defaultType.checked=true;
        }
        updateVisibility();
        clearTimeout(saveTimer);
        syncAfterSave(saveAttributes());
        setTimeout(()=>root.querySelector('[data-invoice-type]')?.focus(),20);
      }else{
        syncAfterSave(resetInvoiceData());
      }
    });

    typeInputs.forEach(input=>input.addEventListener('change',()=>{updateVisibility();clearError('customer_type');clearError('company');clearError('vat');clearError('tax_id');queueSave()}));
    countrySelect?.addEventListener('change',()=>{updateVisibility();clearError('country');clearError('tax_id');queueSave()});
    root.querySelectorAll('input[name^="attributes["]').forEach(input=>{
      if(input===requestedInput||input.matches('[data-invoice-type]'))return;
      input.addEventListener('input',()=>{
        const key=input.dataset.invoiceField;
        if(input===taxInput&&isItaly())input.value=input.value.toUpperCase();
        if(key)clearError(key);
        queueSave();
      });
      input.addEventListener('change',()=>queueSave());
    });

    form?.addEventListener('submit',async event=>{
      if(checkoutReady)return;
      const submitter=event.submitter;
      const isCheckout=submitter?.name==='checkout'||submitter?.matches?.('[data-cart-checkout]');
      setCountryAttributes();
      if(!isCheckout)return;
      event.preventDefault();
      if(checkoutSaving||!validate())return;
      clearTimeout(saveTimer);
      checkoutSaving=true;
      submitter.disabled=true;
      submitter.setAttribute('aria-busy','true');
      try{
        await saveAttributes();
        await syncBollo();
        checkoutReady=true;
        submitter.disabled=false;
        form.requestSubmit(submitter);
      }catch(error){
        if(summary){
          summary.textContent=error?.message||root.dataset.errorSave||'Unable to save the invoice details. Please try again.';
          summary.hidden=false;
          summary.scrollIntoView({block:'nearest'});
        }
      }finally{
        checkoutReady=false;
        checkoutSaving=false;
        submitter.disabled=false;
        submitter.removeAttribute('aria-busy');
      }
    });

    updateVisibility();
    if(toggle?.checked)setCountryAttributes();
    syncBollo().then(changed=>{
      if(changed&&!checkoutSaving)window.location.reload();
    }).catch(showBolloError);
  });
}

document.addEventListener('kjhs:cart-updated',initInvoiceRequest);

function initQuizFallbackLinks(){
  if(document.documentElement.dataset.kjhsQuizFallbackReady==='true')return;
  document.documentElement.dataset.kjhsQuizFallbackReady='true';
  const fallback=document.body?.dataset.quizFallbackUrl||'';
  if(!fallback)return;

  document.addEventListener('click',event=>{
    const link=event.target.closest('a');
    if(!link||!link.closest('.shopify-app-block,[data-quiz],[class*="quiz" i],[id*="quiz" i]'))return;
    const raw=(link.getAttribute('href')||'').trim();
    const invalid=!raw
      || raw==='#'
      || /(?:\/products\/)?(?:undefined|null)(?:[/?#]|$)/i.test(raw)
      || /\/products\/?(?:[?#].*)?$/i.test(raw);
    if(!invalid)return;

    event.preventDefault();
    const current=new URL(location.href);
    const target=new URL(fallback,location.origin);
    if(current.pathname!==target.pathname||current.search!==target.search)location.assign(target.href);
  });
}

/* KJHS: open Shopify Inbox from the customer-support page.
   Inbox owns the widget; this only triggers its existing storefront launcher. */
function kjhsOpenShopifyInbox() {
  const hosts = [
    document.getElementById('ShopifyChat'),
    document.querySelector('inbox-online-store-chat')
  ].filter(Boolean);

  for (const host of hosts) {
    const root = host.shadowRoot;
    if (!root) continue;

    const toggle = root.querySelector('button.chat-toggle, .chat-app > button');
    if (!toggle) continue;

    if (toggle.getAttribute('aria-expanded') !== 'true') {
      toggle.click();
    }
    return true;
  }

  return false;
}

document.addEventListener('click', function (event) {
  const trigger = event.target.closest('[data-open-shopify-inbox]');
  if (!trigger) return;

  event.preventDefault();

  if (kjhsOpenShopifyInbox()) return;

  let attempts = 0;
  const retry = window.setInterval(function () {
    attempts += 1;
    if (kjhsOpenShopifyInbox() || attempts >= 25) {
      window.clearInterval(retry);
    }
  }, 100);
});
